import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  Company,
  Contact,
  InspectionDto,
  Order,
  Project,
  SubProject,
  User
} from '@authority-labs/api-interfaces';
import format from 'date-fns/format';
import he from 'date-fns/locale/he';

@Component({
  selector: 'authority-labs-base-certificate-details',
  templateUrl: './base-certificate-details.component.html',
  styleUrls: ['./base-certificate-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class BaseCertificateDetailsComponent implements OnInit {
  @Input() order: Order;
  @Input() project: Project;
  @Input() subProject: SubProject;
  @Input() company: Company;
  @Input() contact: Contact;
  @Input() inspection: InspectionDto;
  @Input() assignee: User;
  @Input() approval: User;
  @Input() systemDescription: string;
  @Input() systemSubDescription: string;
  @Input() title = 'תעודת בדיקה מס';
  @Input() subTitle = 'תעודה זו מבטלת ומתקנת את תעודה מספר';

  isFix: boolean;
  orderId: string;
  basedOnOrderId: string;
  date: string;

  constructor() {}

  ngOnInit(): void {
    this.date = format(new Date(), 'PPP', {
      locale: he
    });

    this.isFix = this.order.version > 0;

    if (this.isFix) {
      this.orderId = this.isFix
        ? `${this.order.id}-${this.order.version}`
        : String(this.order.id);

      this.basedOnOrderId =
        this.order.version === 1
          ? String(this.order.id)
          : `${this.order.id}-${this.order.version - 1}`;
    } else {
      this.orderId = String(this.order.id);
    }
  }
}
